import React from 'react';
import {
    Modal,
    ModalDialog,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Link,
    Button,
} from 'arag-ui-lib';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ConfirmationDialog = props => {
    const { isOpen, handleClose, executeAction, action, title } = props;
    const { t } = useTranslation();
    return (
        <Modal fadeIn={isOpen} darkenedBackground>
            <ModalDialog>
                <ModalContent>
                    <ModalHeader title={title} onClose={handleClose} />
                    <ModalBody>{action}</ModalBody>
                    <ModalFooter>
                        <Button
                            variant="primary"
                            label={t('confirm')}
                            arrowDirection="left"
                            onClick={executeAction}
                        />
                        <Link
                            type="button"
                            variant="tertiary"
                            arrowDirection="left"
                            label={t('close')}
                            onClick={handleClose}
                        />
                    </ModalFooter>
                </ModalContent>
            </ModalDialog>
        </Modal>
    );
};

ConfirmationDialog.propTypes = {
    executeAction: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    action: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
};

export default ConfirmationDialog;
